/**
 * Builds the COMPLETE OPAL {@link TableLabels} map from the shared `table.*` i18n namespace.
 *
 * TableShell falls back to `DEFAULT_TABLE_LABELS` (English) for any key a consumer omits, and the
 * fallback renders as ordinary prose — there is no raw key to catch in review, so a partial
 * hand-copied map ships English strings into a French/Dutch UI silently (R69). Every list surface
 * therefore builds its labels here rather than restating the map.
 *
 * Call inside a `computed` so the labels follow a locale change:
 * `const tableLabels = computed(() => buildTableLabels(t));`
 *
 * Sibling of {@link buildColumnSettingsLabels}, which does the same for the column-settings drawer.
 */
export function buildTableLabels(t, overrides) {
    return {
        // TableShell / TableHeader root (filter focus fallback)
        tableLabel: t("table.ariaLabel"),
        // TableControls
        filterButton: t("table.filter"),
        eraseAll: t("table.eraseAll"),
        hideFilters: (count) => t("table.hideFilters", { count }),
        showFilters: (count) => t("table.showFilters", { count }),
        saveView: t("table.saveView"),
        shareView: t("table.shareView"),
        // TableSearch
        closeSearch: t("table.closeSearch"),
        // FilterPill
        removeFilter: (label) => t("table.removeFilter", { label }),
        // TableViewSettings
        renameView: t("table.renameView"),
        setAsDefault: t("table.setAsDefault"),
        deleteView: t("table.deleteView"),
        manageViews: t("table.manageViews"),
        viewSettingsLabel: t("table.viewSettingsLabel"),
        // TableViewSelector
        viewModeTable: t("table.viewModeTable"),
        viewModeBoard: t("table.viewModeBoard"),
        viewModeCalendar: t("table.viewModeCalendar"),
        viewModeGantt: t("table.viewModeGantt"),
        // TableViewTabs
        viewTabsLabel: t("table.tabs.preFilteredLists"),
        viewTabsOverflowLabel: t("table.tabs.lists"),
        ...overrides,
    };
}
